export const currentYear = () => {
    let date = new Date();
    return date.getFullYear();
};
